export default function LanguagesReducer(language = [], action) {
	switch (action.type) {
		case "SAVE_LANGUAGES":
			return action.payload;

		default:
			return language;
	}
}
